import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  canonical
}) => {
  // 基本資訊
  const siteName = 'CaesarTechStudio';
  const defaultTitle = '凱撒數位科技股份有限公司｜智慧轉型專家';
  const defaultDescription = '凱撒數位科技專注於企業數位轉型與AI技術導入，提供專業顧問與開發服務。';
  const defaultKeywords = '凱撒數位, 數位轉型, AI導入, 系統整合, 客製化開發';
  // 使用固定的完整URL路徑，不依賴環境變數
  const defaultImage = '/seo-image/og-default.png';
  const siteUrl = 'https://www.caesartechstudio.com';  // 確保域名一致，添加www

  // 簡化邏輯，確保使用完整URL
  const fullImage = image?.startsWith('http') 
                    ? image 
                    : `${siteUrl}${image?.startsWith('/') ? image : defaultImage}`;
                   
  const fullUrl = `${siteUrl}${url || ''}`;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : fullUrl;

  return (
    <Helmet
      htmlAttributes={{ lang: 'zh-TW' }}
    >
      {/* 基本 Meta */}
      <title>{title || defaultTitle}</title>
      <meta name="title" content={title || defaultTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta charSet="utf-8" />

      {/* Favicon 相關設定 */}
      <link rel="icon" href="/assets/images/favicon.ico" />
      <link rel="shortcut icon" href="/assets/images/favicon.ico" type="image/x-icon" />
      <link rel="icon" type="image/x-icon" href="/assets/images/favicon.ico" sizes="16x16 32x32" />
      <link rel="apple-touch-icon" href="/assets/images/logo.png" />
      <meta name="msapplication-TileImage" content={`${siteUrl}/assets/images/logo.png`} />
      <meta name="msapplication-TileColor" content="#4a6cf7" />

      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter Card */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title || defaultTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={fullImage} />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  canonical: PropTypes.string
};

export default SEO;